import { useEffect, useState } from 'react'

/**
 * Fetches the property image URL for a house number from our own API route
 * (which holds the PCB key). Returns undefined until it arrives, and forever
 * when anything goes wrong, so callers keep showing their placeholder.
 */
export const useBookingImage = (houseNumber: string): string | undefined => {
  const [imageUrl, setImageUrl] = useState<string>()

  useEffect(() => {
    const controller = new AbortController()
    const params = new URLSearchParams({ houseNumber })

    fetch(`/auth/api/booking-image-route?${params.toString()}`, {
      signal: controller.signal,
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((body) => {
        if (typeof body?.imageUrl === 'string') {
          setImageUrl(body.imageUrl)
        }
      })
      .catch(() => {
        // aborted or failed: the placeholder stays
      })

    return () => controller.abort()
  }, [houseNumber])

  return imageUrl
}
